/** Returns MPX account url */
export const getMpxAccountURL = () => {
  const accountId = process.env.REACT_APP_MPX_ACCOUNT_ID || ''
  return `http://access.auth.theplatform.com/data/Account/${accountId}`
}

/** Returns formatted token in base 64 */
export const getFormattedTokenInBase64 = (token) => {
  token = token || ''
  const account = getMpxAccountURL() || ''
  return `Basic ${window.btoa(unescape(encodeURIComponent(`${account}:${token}`)))}`
}
